import { handleActions } from "redux-actions";
import {
  FETCH,
  FETCH_FAILURE,
  FETCH_SUCCESS,
  SET_SOLVED,
  SET_FOCUS,
  SET_VALUE,
  CLEAR_VALUES
} from "./actions";
import { DEFAULT_LEVEL } from "../../constants/index";
import { stateId } from "../../helpers/id";
import { getDefaultLang } from "../../helpers/locale";

const initialState = {
  loading: false,
  loaded: false,
  solved: false,
  hints: true,
  id: null,
  lang: getDefaultLang(),
  level: DEFAULT_LEVEL,
  seed: null,
  secret: "",
  data: null,
  values: {},
  prevFocus: { x: null, y: null },
  focus: { x: null, y: null },
  alphabet: [],
  next: {
    seed: null,
    level: null
  },
  prizes: []
};

export default handleActions(
  {
    [FETCH]: state => ({
      ...state,
      loading: true,
      solved: initialState.solved,
      values: initialState.values,
      prevFocus: initialState.prevFocus,
      focus: initialState.focus
    }),
    [FETCH_SUCCESS]: (state, { payload }) => ({
      ...state,
      secret: "",
      ...payload,
      loading: false,
      loaded: true,
      id: stateId(payload),
      next: initialState.next
    }),
    [FETCH_FAILURE]: (state, { payload }) => ({
      ...state,
      ...payload,
      loading: false,
      loaded: false
    }),
    [SET_SOLVED]: (state, { payload }) => ({
      ...state,
      next: {
        seed: payload.seed || initialState.next.seed,
        level: payload.level || initialState.next.level
      },
      prizes: payload.prizes || initialState.prizes,
      solved: Boolean(payload.solved)
    }),
    [SET_FOCUS]: (state, { payload }) => ({
      ...state,
      focus: { ...payload },
      prevFocus: { ...state.focus }
    }),
    [SET_VALUE]: (state, { payload }) => ({
      ...state,
      values: {
        ...state.values,
        [payload.x]: {
          ...state.values[payload.x],
          [payload.y]: payload.value
        }
      }
    }),
    [CLEAR_VALUES]: state => ({
      ...state,
      solved: initialState.solved,
      values: initialState.values,
      prevFocus: initialState.prevFocus,
      focus: initialState.focus
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/crossword/reducer.js